/**
 * 导入 2020-12-22
 */
import React from 'react';
import { connect } from 'dva';

import { component_tool, framework_tool } from '@/tool'
let { WizTypography, WizSpin } = component_tool;
let { WizContainer } = framework_tool;
const { Paragraph } = WizTypography;
import { ExportExcel } from '@/components/index'
import { modelUtils } from '@/utils'

class BatchPositionAuthStateImport extends WizContainer {

  componentName = 'batchPositionAuthStateImport';

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  /**
   * 更新原列表
   */
  refreshList() {
    let { changeModal } = this.props;
    changeModal && changeModal(false, true)
  }

  _handldImport(nextProps, nextState) {
    let o = nextProps['detailImport']
    if (o['success']) {
      let data = o['data'];
      let str = data.replace(/<br\/>/g,"\n")
      wizNotice.success({
        key:'default',
        message:'成功',
        description: (
          <div>
            <p style={{whiteSpace: "pre-line"}}>{str}</p>
          </div>
        ),
      })
      this.refreshList();
      return true;
    } else {
      if(o['msg']){
        wizNotice.error({ key:'batch-positionAuth-error',message:'出错了', description: <div dangerouslySetInnerHTML={{ __html: o.msg || "导入失败" }} /> })
      }else{
        wizNotice.error("导入数据出错，请联系相关人员")
      }
      return false;
    }
  }

  propsAndStateOnChange = {
    detailImport: this._handldImport.bind(this),
  }


  _render() {

    let infoProps = {
      title: '导入说明',
      text: [
        <Paragraph>1、从模版链接中下载模版文件</Paragraph>,
        <Paragraph>2、按照要求格式填写信息</Paragraph>,
        <Paragraph>3、当完成Excel文件的填写后，点击“上传文件”按钮上传此文件</Paragraph>,
      ]
    }
    let operateProps = {
      title: '批量岗位认证导入',
      template: {
        label: '模版下载',
        fileName: '模版.xlsx',
        href: constants.files.excel_batchPositionAuthStateImportTemp,
      }

    }
    let submit = (file, fileData) => {
      let apiPath = 'requirementPersonnel/batchPositionAuthStateImport';
      this.doAction({
        path: apiPath,
        payload: {
          key: "import",
          apiParams: {
            fileData,
          }
        }
      });
    }
    let { requirementPersonnelLoading } = this.props;
    return (
      <WizSpin tip={'文件上传中'} spinning={requirementPersonnelLoading}>
        <ExportExcel
          infoProps={infoProps}
          operateProps={operateProps}
          submit={submit}
        />
      </WizSpin>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { requirementPersonnel } = state;
  const detailImport = modelUtils.getModelEntity(requirementPersonnel, 'import');
  //获取loading的方式
  const load = modelUtils.getLoadingState(state, 'requirementPersonnel')
  return {
    detailImport: detailImport,
    ...load
  }
};

export default connect(mapStateToProps)(BatchPositionAuthStateImport);
